import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import PasswordForm from '../../../components/forms/PasswordForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import ChangePasswordAction from '../../../actions/auth/ChangePasswordAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class ChangePasswordPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When password is successfully changed, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Mot de passe modifié.')
      this.props.onClose()
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.changePassword(data)
  }

  render() {
    return (
      <Popup
        header='Changer le mot de passe'
        body={
          <PasswordForm
            username={this.props.username}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: this.props.onClose
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

ChangePasswordPopup.propTypes = {
  // Properties
  onClose: PropTypes.func.isRequired,

  // Redux State
  username: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,

  // Redux Actions
  changePassword: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    username: state.app.identity.user.name,
    isSaving: state.app.password.isFetching,
    error: state.app.password.error
  }),
  (dispatch) => ({
    changePassword: (data) => (dispatch(ChangePasswordAction({ data }))),
    clearError: () => (dispatch(ClearErrorAction(Types.AUTH.PASSWORD)))
  })
)(ChangePasswordPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/users/ChangePasswordPopup.js